import { useMutation, useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';

import { selectUserIsLogged } from 'selectors/user';

import GetUserProfileProperties from '../creators/GetUserProfileProperties.graphql';
import GetUserProperty from '../creators/GetUserProperty.graphql';
import UpdateUserProperty from '../creators/UpdateUserProperty.graphql';

export const useUserProperty = (propertyName, options = {}) => {
  const isLoggedIn = useSelector(selectUserIsLogged);

  const { onError } = options;
  const { loading, error, data } = useQuery(GetUserProperty, {
    variables: { name: propertyName },
    onError: err => onError && onError(err),
    skip: !isLoggedIn,
  });

  return {
    loading,
    error,
    value: data?.result?.value,
  };
};

export const useUserProfileProperty = (userId, options = {}) => {
  const { onError } = options;
  const { loading, error, data } = useQuery(GetUserProfileProperties, {
    variables: { userId },
    onError: err => onError && onError(err),
  });

  return {
    loading,
    error,
    value: data?.result?.value,
  };
};

export const useUpdateUserProperty = (propertyName, options = {}) => {
  const { onCompleted, onError } = options;
  const [updateUserProperty, { loading, error }] = useMutation(
    UpdateUserProperty,
    {
      onCompleted: data => onCompleted && onCompleted(data),
      onError: err => onError && onError(err),
      update: (cache, updatedData) => {
        cache.writeQuery({
          query: GetUserProperty,
          variables: { name: propertyName },
          data: {
            result: updatedData?.data?.result?.property,
          },
        });
      },
    }
  );

  const boundUpdate = propertyValue => {
    updateUserProperty({
      variables: {
        name: propertyName,
        value: propertyValue,
      },
    });
  };

  return {
    updateUserProperty: boundUpdate,
    loading,
    error,
  };
};
